import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { cosUrl } from '../const/menuData';
import Header from './common/Header/index.jsx';
import GeneralBasicOCR from './GeneralBasicOCR.jsx';
import OcrUpload from './common/Upload.jsx';

import ThumbnailPreview from './common/ThumbnailPreview.jsx';
import ImageOptimize from './ImageOptimize';
import { Thumbnail } from "@tencent/universe-ui/build/lib";
import { getRectPosition, customRound } from '../utils/index';
import useSmoothScroll from 'react-smooth-scroll-hook';
import Sider from './common/Sider/index.jsx';
import '../style/layout.css'; // 引入样式文件

const imgFileType = ["jpg", "jpeg", "png", "bmp", "JPG", "JPEG", "PNG", "BMP"]

const OcrLayout = forwardRef(({ menuList, currentMune, defaultNavItems, action, onChangeAction }, ref) => {
  const [range, setRange] = useState(50);
  const [angle, setAngle] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [imgPreType, setImgPreType] = useState('preview'); // preview || col || split
  const [showImgList, setShowImgList] = useState(true);
  const [imgListType, setImgListType] = useState('default');  //  default | upload
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);
  const [imglist, setImglist] = useState([]);
  const [uploadImglist, setUploadImglist] = useState([]);
  const [curItem, setCurItem] = useState(''); //  当前选中action
  const [curImg, setCurImg] = useState(null);
  const [result, setResult] = useState(null);
  const [prefix, setPrefix] = useState('Image');
  const [totalPage, setTotalPage] = useState(1);
  const [selectRectKey, setSelectRectKey] = useState('');
  const [clipImg, setClipImg] = useState('');
  const [showThumListBtn, setShowThumListBtn] = useState(false);

  const [isImageError, setIsImageError] = useState(true);
  const [rects, setRects] = useState([]);
  const [rectDocuments, setRectDocuments] = useState([]);
  const uploadRef = useRef();
  const SiderRef = useRef();
  const imgPreRef = useRef();
  const GeneralBasicOCRRef = useRef();
  const domRef = useRef(document.body);
  const thumbnailRef = useRef();
  const { scrollTo } = useSmoothScroll({
    ref: domRef,
    speed: 100,
    direction: 'x',
  });

  // 使用useImperativeHandle暴露setConfig方法给父组件
  useImperativeHandle(ref, () => ({
    setMenuConfig: (_result) => {
      setConfig(_result);
      SiderRef.current?.setCurMenu(_result);
    }
  }));

  // 切换图片/项目时，清空rect
  useEffect(() => {
    if (!curItem) return;
    setRectDocuments([]);
    setSelectRectKey('');
    setRects([]);
    setClipImg('');
    setShowImgList(true);
    // setUploadImglist([]);
  }, [curItem, curImg?.url])

  // 切换图片/项目时，清空rect
  useEffect(() => {
    setUploadImglist([]);
    setImgListType('default')
  }, [curItem])

  useEffect(() => {
    if (rectDocuments.length > 0) {
      const _rects = rectDocuments.map(r => {
        return {
          ...r,
          visible: true
        }
      })
      setRects(_rects);
    } else {
      setRects([]);
    }
  }, [rectDocuments])

  useEffect(() => {
    async function func() {
      // TODO: 获取菜单值
      setConfig(currentMune);
    }
    func();

  }, [currentMune])

  const setConfig = (_result) => {
    if (!_result) return;
    const prefix = _result.prefix || 'Image';
    setPrefix(prefix);
    const imgList = _result?.imglist?.map((i, index) => {
      if (typeof i === 'string') {
        return {
          previewUrl: i.indexOf('https') > -1 ? i : cosUrl + i,
          url: i.indexOf('https') > -1 ? i : cosUrl + i, //  图片预览地址
          OriginUrl: i.indexOf('https') > -1 ? i : cosUrl + i,  //  图片原始预览地址
          cantPreview: _result?.fakeImglist?.length > 0 ? true : false,
          type: 'url',
          isExample: true,
          pdfImgList: [],
          fileType: i?.split('?')[0].split('.').pop().toLowerCase(),
          prefix: _result?.ImageParams ? _result?.ImageParams : `${prefix}Url`,
          param: _result?.fakeImglist ? (i.indexOf('https') > -1 ? _result?.fakeImglist[index] : cosUrl + _result?.fakeImglist[index]) : ''
        }
      } else {
        return {
          previewUrl: i.url.indexOf('https') > -1 ? i.url : cosUrl + i.url,
          url: i.url.indexOf('https') > -1 ? i.url : cosUrl + i.url, //  图片预览地址
          defaultConfig: i.defaultConfig,
          OriginUrl: i.url.indexOf('https') > -1 ? i.url : cosUrl + i.url, //  图片原始预览地址
          cantPreview: _result?.fakeImglist?.length > 0 ? true : false,
          type: 'url',
          isExample: true,
          pdfImgList: [],
          fileType: i.url.split('?')[0].split('.').pop().toLowerCase(),
          prefix: _result?.ImageParams ? _result?.ImageParams : `${prefix}Url`,
          param: _result?.fakeImglist ? (i.indexOf('https') > -1 ? _result?.fakeImglist[index] : cosUrl + _result?.fakeImglist[index]) : ''
        }
      }
    })
    setImglist(imgList);
    setCurImg(imgList[0]);
    setTotalPage(1);
    setResult(imgList[0]);
    setImgPreType(_result?.isImageResult ? 'split' : 'preview');
    setCurItem(_result);
    // 处理图片显示
    if (domRef?.current?.clientWidth < imgList?.length * 94) {
      setShowThumListBtn(true)
    } else {
      setShowThumListBtn(false)
    }
  }
  return (
    <div className="pg-recognize">
      <Header
        onChangeAction={onChangeAction}
        relatedTitle={curItem.relatedTitle}
        title={curItem.title}
        action={curItem.action}
        apiUrl={
          curItem.url
        }
        consoleUrl={
          curItem.consoleUrl
        }
        isActive={
          !isMenuCollapsed
        } />
      <div className="pg-layout">
        <Sider
          cRef={SiderRef}
          setConfig={setConfig}
          menuList={menuList}
          defaultNavItems={defaultNavItems}
          action={action}
          currentMune={currentMune}
          setCollapsed={setIsMenuCollapsed}
          collapsed={isMenuCollapsed}
        />
        <div className="auto-flex" style={{ background: '#F4F5F7', height: '100%', flex: 1 }}>
          <div className="preview_container" >
            {
              // curImg && !isImageError && !isLoading && <>
              <>
                {
                  imgPreType === 'preview' ? <ThumbnailPreview
                    needClip={curItem.actionType === 'eduAgent'}
                    showLabel={curItem.actionType === 'markEdu'}
                    angle={angle}
                    isLoading={isLoading}
                    isShow={curImg && !isImageError && !isLoading}
                    cRef={imgPreRef}
                    showImgList={showImgList}
                    rects={rects}
                    selectRect={selectRectKey}
                    style={{ background: '#fff' }}
                    onUpload={() => {
                      uploadRef.current.onUpload();
                    }}
                    onSelect={
                      (val) => {
                        setSelectRectKey(val);
                      }
                    }
                    onClip={
                      (val) => {
                        setClipImg(val);
                      }
                    }
                    imageList={curImg?.pdfImgList?.length > 0 ? curImg.pdfImgList : []}
                    imageUrl={curImg?.previewUrl || curImg?.url}
                  /> : <>
                    <ImageOptimize type="split" defaultRange={range} getRange={e => {
                      setRange(e)
                    }} imgList={[`data:image/png;base64,${result.url}`, curImg?.pdfImgList?.[0]?.ImageUrl ?? curImg?.url]} tips={curItem?.imageResultTips || ['增强后', '原图']} />
                  </>
                }
              </>
            }
          </div>
          <div className="ocrDemo-imgListType-container">
            <div className={`ocrDemo-imgListType-item ${imgListType === 'default' ? 'active' : ''}`}
              onClick={() => setImgListType('default')}>示例文件</div>
            <div className="ocrDemo-imgListType-slice"></div>
            <div className={`ocrDemo-imgListType-item ${imgListType === 'upload' ? 'active' : ''}`}
              onClick={() => setImgListType('upload')}>上传文件</div>
            {
              imgListType === 'upload' && uploadImglist.length > 0 &&
              <div className={`ocrDemo-imgListType-del ${uploadImglist?.length > 0 ? '' : 'disable'}`}
                onClick={() => {
                  setUploadImglist([]);
                }}>
                <span className="ocrDemo-icon ocrDemo-icon__del"></span>
                <span>清除所有上传</span>
              </div>
            }

          </div>
          <div className="imgList_scrollView-container" >
            <div className={`imgList_scrollView`} ref={domRef} >
              <div
                className="unv-thumbnail-list" ref={thumbnailRef} >

                {
                  imgListType === 'upload' &&
                  <>
                    <div className="ocrDemo-icon_uploadEmpty" onClick={() => {
                      uploadRef.current.onUpload();
                    }}></div>
                    {
                      uploadImglist?.map((i, index) => (
                        <>
                          <div className="ocrDemo-imgItem-container uploadList" onClick={() => {
                            if (isLoading) return;
                            setCurImg(i);
                            setTotalPage(i.pdfImgList?.length || 1);
                            setResult(i);
                            GeneralBasicOCRRef?.current?.start({ image: i })
                          }}>
                            <Thumbnail
                              key={index}
                              fileType={i.fileType}
                              active={curImg?.url === i.url || curImg?.OriginUrl === i.OriginUrl}
                              imageUrl={i.previewUrl || i.url}
                            />
                            <div className="ocrDemo-imgItem__delete">
                              <div className="ocrDemo-icon_delete" onClick={(e) => {
                                e.stopPropagation();
                                uploadImglist.splice(index, 1);
                                setUploadImglist([...uploadImglist]);
                              }}></div>
                            </div>
                            {
                              i.fileType && <div className={`ocrDemo-imgItem__fileType ${imgFileType.includes(i.fileType) ? 'img' : 'file'}`}>{i.fileType}</div>
                            }
                          </div>
                        </>
                      ))
                    }

                  </>
                }
                {
                  imgListType === 'default' && imglist?.map((i, index) => (
                    <div className="ocrDemo-imgItem-container" onClick={() => {
                      if (isLoading) return;
                      setCurImg(i);
                      setTotalPage(i.pdfImgList?.length || 1);
                      setResult(i);
                      GeneralBasicOCRRef?.current?.start({ image: i, config: i.defaultConfig })
                    }}>
                      <Thumbnail
                        key={index}
                        fileType={i.fileType}
                        active={curImg?.url === i.url || curImg?.OriginUrl === i.OriginUrl}
                        imageUrl={i.previewUrl || i.url}
                      />
                      {
                        i.fileType && <div className={`ocrDemo-imgItem__fileType ${imgFileType.includes(i.fileType) ? 'img' : 'file'}`}>{i.fileType}</div>
                      }
                    </div>

                  ))
                }
              </div>
            </div>
            <div className={`${showThumListBtn ? 'isActive' : 'isHide'} imgList_scrollView__btn`} onClick={() => {
              scrollTo(200)
            }}></div>
          </div>
          <OcrUpload
            cRef={uploadRef}
            prefix={prefix}
            maxLength={curItem.maxLength}
            acceptList={curItem.acceptList}
            curItem={curItem}
            onSuccess={({ img, type, imgList }) => {
              setImgListType('upload');
              setIsImageError(true);
              // setUploadImglist([img,...uploadImglist]);
              GeneralBasicOCRRef?.current?.start({ image: img })
            }} />
        </div>
        <div flex style={{ background: '#F4F5F7', width: '35%', maxWidth: '35%', minWidth: '520px', padding: '20px', flex: 1 }}>
          <GeneralBasicOCR
            onAddMenu={(menu) => {
              SiderRef?.current?.addRecentMenu(menu)
            }}
            image={curImg}
            clipImg={clipImg}
            selectRect={selectRectKey}
            totalPage={totalPage}
            setIsLoading={setIsLoading}
            onSelect={(textVal, rectVal) => {
              setSelectRectKey(rectVal);
              imgPreRef?.current?.onRectChange(rectVal)
            }}
            cRef={GeneralBasicOCRRef}
            uploadImglist={uploadImglist}
            onLoading={res => setIsLoading(res)}
            onResult={({ isError = false, image, rsp, requestParams, config = curItem, uploadImglist = uploadImglist, rect, select }) => {
              setIsLoading(true);
              const _config = config || curItem;
              const pdfList = rsp.auditData?.length > 0 && rsp.auditData[0].ImageUrl ? rsp.auditData : [];
              
              // 处理角度设置
              if ([0, 90, 180, 270, 360].includes(customRound(rsp?.Angle)) && pdfList.length <= 0 && curItem.supportAngle) {
                setAngle(customRound(rsp.Angle))
              } else {
                setAngle(0)
              }
              
              setTotalPage(rsp?.auditData?.length || 1);

              // 处理QuestionOCR相关逻辑
              const handleQuestionOCR = () => {
                let previewUrl = pdfList.length > 0 ? pdfList[0].ImageUrl : image.url;
                let imgSize = null;
                
                if (rsp && rsp?.QuestionInfo?.length > 0) {
                  imgSize = {
                    width: rsp?.QuestionInfo[0].Width,
                    height: rsp?.QuestionInfo[0].Height
                  };
                  if (rsp?.QuestionInfo[0]?.ImageBase64) {
                    previewUrl = `data:image/png;base64,` + rsp.QuestionInfo[0].ImageBase64;
                  }
                }

                const _curImg = {
                  ...image,
                  cantPreview: false,
                  pdfImgList: [],
                  OriginUrl: image.url,
                  url: image.url,
                  previewUrl: previewUrl
                };
                
                updateCurrentImage(_curImg, !_curImg.isExample);
                imgPreRef?.current?.onPreChange({
                  curImg: previewUrl,
                  curpPdfList: [],
                  imgSize: imgSize
                });
              };

              // 处理其他OCR逻辑
              const handleOtherOCR = () => {
                let imgSize = null;
                if (rsp && rsp?.QuestionInfo?.length > 0) {
                  imgSize = {
                    width: rsp?.QuestionInfo[0].Width,
                    height: rsp?.QuestionInfo[0].Height
                  };
                }
                imgPreRef?.current?.onPreChange({
                  curImg: image.url,
                  curpPdfList: pdfList,
                  imgSize: imgSize
                });
                
                const _curImg = {
                  ...image,
                  pdfImgList: pdfList,
                  previewUrl: pdfList.length > 0 ? pdfList[0].ImageUrl : image.previewUrl || image.url,
                  cantPreview: false,
                };
                
                updateCurrentImage(_curImg, !_curImg.isExample);
              };

              // 更新当前图片和上传列表
              const updateCurrentImage = (_curImg, shouldUpdateUploadList) => {
                setCurImg(_curImg);
                if (shouldUpdateUploadList) {
                  const existingIndex = uploadImglist.findIndex(item => item.url === _curImg.url);
                  if (existingIndex !== -1) {
                    uploadImglist[existingIndex] = _curImg;
                    setUploadImglist([...uploadImglist]);
                  } else {
                    setUploadImglist([_curImg, ...uploadImglist]);
                  }
                }
              };

              // 处理矩形框数据
              const handleRectData = () => {
                if (rect?.length > 0) {
                  return rect;
                }
                
                let _rects = [];
                const isWordListOnly = _config?.rectConfig?.showWordListOnly;
                const showWordList = _config?.rectConfig?.useWordList && rsp?.WordList?.length > 0;
                
                if (isWordListOnly) {
                  _rects = processRectConfig(_config, rsp, pdfList, requestParams, 'WordListRectConfig');
                } else {
                  if (showWordList) {
                    _rects = processRectConfig(_config, rsp, pdfList, requestParams, 'WordListRectConfig');
                  }
                  if (showWordList || !isWordListOnly) {
                    const additionalRects = processRectConfig(_config, rsp, pdfList, requestParams, 'rectConfig');
                    _rects.push(...additionalRects);
                  }
                }
                
                return _rects;
              };

              // 处理矩形配置
              const processRectConfig = (config, data, pdfList, requestParams, configType) => {
                let rects = [];
                const configData = config[configType];
                
                if (Array.isArray(configData)) {
                  configData.forEach(configItem => {
                    const rect = getRectPosition({
                      data: data,
                      config: configItem,
                      isMulPage: pdfList.length > 1,
                      total: pdfList.length,
                      PdfPageNumber: requestParams?.PdfPageNumber || 1
                    });
                    rects.push(...rect);
                  });
                } else if (configData) {
                  const rect = getRectPosition({
                    data: data,
                    config: configData,
                    isMulPage: pdfList.length > 1,
                    total: pdfList.length,
                    PdfPageNumber: requestParams?.PdfPageNumber || 1
                  });
                  rects.push(...rect);
                }
                return rects;
              };

              // 主逻辑分发
              if (['QuestionOCR','QuestionSplitOCR','QuestionSplitLayoutOCR'].includes(_config.action) ) {
                handleQuestionOCR();
              } else {
                handleOtherOCR();
              }

              if (!isError) {
                setTimeout(() => {
                  const _rects = handleRectData();
                  console.log('key rects', _rects)
                  setRectDocuments(_rects);
                  setShowImgList(false);
                }, 0);
              }

              setIsLoading(false);

            }}
            onImageError={(res) => {
              setIsImageError(res);
              if (res) {
                // 图片审核不通过
                setCurImg('');
              }
            }}
            onChangeImg={
              (img, params) => {
                const _curImg = {
                  ...curImg,
                  url: img,
                  previewUrl: img,
                  OriginUrl: img
                }
                setCurImg(_curImg);
                GeneralBasicOCRRef?.current?.start({ image: _curImg, config: params })
              }
            }
            onChangeImageEnhancement={(res) => {
              setResult({ //  文本图像增强
                url: res.url
              });
              setImgPreType(res.type);
            }}
            detail={curItem}
          />
        </div>
      </div>
    </div>
  );
})

export default OcrLayout;
